<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container p-5">
      <div class="mb-2 text-center">
        <ErrorsMessages :errors="errors" />
      </div>
      <button
        type="button"
        :loading="loading"
        :disabled="loading"
        @click="execute"
        class="btn btn-block btn-save btn-success"
      >
        EXECUTAR
      </button>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "MeidicineDuplicate",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },

  data() {
    return {
      loading: false,
      errors: [],
    };
  },

  methods: {
    async execute() {
      try {
        this.loading = true;

        let response = await api.post("/medicine-duplicate");

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
